import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, LibraryComponentType, Text, theme } from 'yolda-web-ui'
import {
  StyledButtonGroup,
  StyledPackageOrVehicleWrapper,
  StyledPickupWithoutBarcodeQuestion,
} from './PickupWithoutBarcodeQuestion.style'
import { Icon, Packages, Vehicles, YoldaIcons } from '../../atoms'
import { Trip } from '../../../utils/constants/Trip'
import { ShipmentType } from '../../../utils/constants/Shipment'
import { makePackageData, makeVehicleData } from '../../../utils/helpers'

interface PickupWithoutBarcodeQuestionProps extends LibraryComponentType {
  onAction?: () => void
  onCallSupport?: () => void
  item: Trip
}

const PickupWithoutBarcodeQuestion: FC<PickupWithoutBarcodeQuestionProps> = ({
  onCallSupport,
  onAction,
  item,
  onClose,
}) => {
  const { t } = useTranslation()

  const onClickPickup = () => {
    onAction?.()
    onClose?.()
  }

  const onClickCallSupport = () => {
    onCallSupport?.()
    onClose?.()
  }

  return (
    <StyledPickupWithoutBarcodeQuestion>
      <div>
        <Icon iconName={YoldaIcons.HubDoneGray} />
      </div>
      <Text as="h1" fontSize="large" fontWeight="normal" mb={theme.spacing.medium} mt={theme.spacing.medium}>
        {`${t('trip.pickupWithoutBarcodeQuestion.title')}`}
      </Text>
      <StyledPackageOrVehicleWrapper>
        {item?.shipmentType === ShipmentType.FTL ? (
          <Vehicles
            data={makeVehicleData(
              item?.carrierVehicle?.vehicleType || '',
              item?.carrierVehicle?.vehicleBodyType || '',
              t
            )}
          />
        ) : (
          <Packages data={makePackageData(item?.packageSummary || {}, t)} />
        )}
      </StyledPackageOrVehicleWrapper>

      <Text as="p" fontSize="medium" mb={theme.spacing.large} mt={theme.spacing.large}>
        {`${t('trip.pickupWithoutBarcodeQuestion.desc')}`}
      </Text>
      <StyledButtonGroup>
        <Button onClick={onClickPickup} stretch>{`${t(
          'trip.pickupWithoutBarcodeQuestion.completeButton'
        )}`}</Button>
        <Button onClick={onClickCallSupport} stretch variant="outline">{`${t(
          'trip.pickupWithoutBarcodeQuestion.callSupportButton'
        )}`}</Button>
      </StyledButtonGroup>
    </StyledPickupWithoutBarcodeQuestion>
  )
}

PickupWithoutBarcodeQuestion.defaultProps = {
  onAction: () => null,
  onCallSupport: () => null,
  item: undefined,
}

export default PickupWithoutBarcodeQuestion
